import { MinutosIntervalo, TurnoConsulta } from '../../core/models/rada-productividad.models';

export interface RadaOpcion<T> {
  label: string;
  value: T;
}

// ── Filtros ────────────────────────────────────────────────────────────

/** Turno de consulta: el valor viaja tal cual al backend (T = Todos, M = Mañana, N = Noche). */
export const TURNO_OPTIONS: RadaOpcion<TurnoConsulta>[] = [
  { label: 'Todos', value: 'T' },
  { label: 'Mañana', value: 'M' },
  { label: 'Noche', value: 'N' },
];

/** Tamaño del intervalo en minutos, contado desde las 06:00 del día operativo (R2.3). */
export const INTERVALO_OPTIONS: RadaOpcion<MinutosIntervalo>[] = [
  { label: '60 min', value: 60 },
  { label: '45 min', value: 45 },
  { label: '30 min', value: 30 },
  { label: '15 min', value: 15 },
];

export const TURNO_DEFAULT: TurnoConsulta = 'T';
export const INTERVALO_DEFAULT: MinutosIntervalo = 60;

// ── Refresco en vivo ───────────────────────────────────────────────────

/** Cadencia del refresco del día en curso (R2.7 y R7.6). */
export const RADA_REFRESCO_MS = 60_000;

// ── Permisos (serv_nombre en el árbol de permisos del login) ───────────

export const RADA_PERMISOS = {
  PROD_VER: 'RADA_PROD_VER',
  METAS_EDITAR: 'RADA_METAS_EDITAR',
  ACT_RECALCULAR: 'RADA_ACT_RECALCULAR',
  TV_VER: 'RADA_TV_VER',
  TV_CONFIG: 'RADA_TV_CONFIG',
} as const;

export type RadaPermiso = (typeof RADA_PERMISOS)[keyof typeof RADA_PERMISOS];

// ── Rutas de las pantallas (deben coincidir con menu_url del backend) ──

export const RADA_RUTAS = {
  PRODUCTIVIDAD: '/rada/productividad-despacho',
  METAS: '/rada/metas-activacion',
  DASHBOARD: '/rada/dashboard-activacion',
  MODO_PANTALLA: '/rada/modo-pantalla',
} as const;

/** queryParam con la planta que viaja de Productividad a Metas de activación (R2.9). */
export const RADA_PARAM_PROV = 'prov';
